import { type FieldValues } from 'react-hook-form';
import { DelimitedArrayParam, NumberParam, type QueryParamConfigMap, withDefault } from 'serialize-query-params';

import { DEFAULT_PAGINATION, DEFAULT_SORTING, getEmptyDate } from '@/hooks/useEntityList';

export const COMPOUND_FORM_VALUE_KEYS = [
  'process.availability',
  'process.talentsCount',
  'process.createdAt',
  'process.updatedAt',
  'talents.createdAt',
  'talents.lastActivity'
];

export const DEFAULT_VALUES = {
  process: {
    search: '',
    assessmentType: [],
    status: [],
    availability: getEmptyDate(),
    office: null,
    organization: null,
    createdBy: [],
    keyAccountManager: [],
    talentsCount: { min: 0, max: 10000 }
  },
  testTemplates: {
    search: '',
    status: null,
    score: null,
    aiWebcam: []
  },
  talents: {
    searchByName: '',
    searchByEmail: '',
    searchByPhone: '',
    type: null,
    status: null,
    createdAt: getEmptyDate(),
    updatedAt: getEmptyDate()
  },
  ...DEFAULT_SORTING,
  ...DEFAULT_PAGINATION
} as never as FieldValues;

export const URL_CONFIG_MAP = {
  'process.assessmentType': DelimitedArrayParam,
  'process.status': DelimitedArrayParam,
  'process.createdBy': DelimitedArrayParam,
  'process.kam': DelimitedArrayParam,
  'process.talentsCount.min': NumberParam,
  'process.talentsCount.max': NumberParam,
  'testTemplates.aiWebcam': DelimitedArrayParam,
  size: withDefault(NumberParam, DEFAULT_PAGINATION.size)
} as QueryParamConfigMap;
